import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

function UserConditions() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>Умови користування LeelaOnline.net</h1>
            <h3>1. Вступ</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                <li className={StaticPageStyles.staticPageText}>Ласкаво просимо на сайт LeelaOnline.net.</li>
                <li className={StaticPageStyles.staticPageText}>Сайт LeelaOnline.net (далі "сайт") є цифровим продуктом для провідників гри Ліла</li>
                <li className={StaticPageStyles.staticPageText}>Сайт призначений для проведення ігор Ліла в електронному вигляді з використанням цифрового поля гри та технологій відеозвязку</li>

                <li className={StaticPageStyles.staticPageText}>Використовуючи цей сайт, ви погоджуєтеся дотримуватися наведених нижче умов користування.</li>
                <li className={StaticPageStyles.staticPageText}>Будь ласка, уважно ознайомтеся з цими умовами перед початком використання нашого сайту.</li>
                </ul>
            </p>

            <h3>2. Прийняття умов</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Використовуючи наш сайт, ви погоджуєтеся з цими умовами користування, політикою конфіденційності
                    та будь-якими іншими правилами та політиками, які можуть бути оновлені.</li>
                    <li className={StaticPageStyles.staticPageText}>Якщо ви не погоджуєтеся з цими умовами, будь ласка, не використовуйте наш сайт.</li>
                </ul>
            </p>

            <h3>3. Зміни умов</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ми залишаємо за собою право змінювати ці умови користування в будь-який час без попереднього повідомлення.</li>
                    <li className={StaticPageStyles.staticPageText}>Ваше подальше використання сайту після внесення змін означає вашу згоду з новими умовами.</li>
                    <li className={StaticPageStyles.staticPageText}>Про зміну умов вам буде повідомлено шляхом надсилання повідомлення не електронну адресу вказану при реєстрації.</li>
                </ul>
            </p>

            <h3>4. Реєстрація</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Для доступу до певних функцій нашого сайту вам може знадобитися створити обліковий запис.</li>
                    <li className={StaticPageStyles.staticPageText}>Ви погоджуєтеся надавати правдиву, точну, актуальну та повну інформацію про себе під час реєстрації.</li>
                    <li className={StaticPageStyles.staticPageText}>Користувач не може мати два або більше облікових записи</li>
                    <li className={StaticPageStyles.staticPageText}>В разі необхідності нової реєстрації при існуючому обліковому записі необхідно видалити попередній обліковий запис через офіційне звернення в службу підтримки</li>
                    <li className={StaticPageStyles.staticPageText}>Ви несете відповідальність за збереження конфіденційності вашого облікового запису та пароля.</li>
                </ul>
            </p>

            <h3>5. Використання сайту</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Ви погоджуєтеся використовувати наш сайт тільки для законних та передбачених цілей та у відповідності з цими умовами користування.</li>
                    <li className={StaticPageStyles.staticPageText}>Ви не маєте права:</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Використовувати сайт у будь-який спосіб, що порушує будь-які застосовні закони чи регулювання.</li>
                        <li className={StaticPageStyles.staticPageText}>Використовувати сайт для передачі або розміщення будь-яких небажаних рекламних або промоційних матеріалів.</li>
                        <li className={StaticPageStyles.staticPageText}>Втручатися або намагатися втручатися в нормальне функціонування сайту.</li>
                    </ul>
                </ul>
            </p>

            <h3>6. Інтелектуальна власність</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Всі матеріали, що містяться на цьому сайті, включаючи текст, графіку, логотипи, іконки, зображення та програмне забезпечення,
                    є власністю нашої компанії або наших ліцензіарів і захищені законами про авторське право та іншими законами про інтелектуальну власність.</li>
                </ul>
            </p>

            <h3>7. Обмеження відповідальності</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Наш сайт надається для використання "як є" та "як доступно" без будь-яких гарантій, явних або неявних.</li>
                    <li className={StaticPageStyles.staticPageText}>Ми не несемо відповідальності за будь-які збитки, що виникли в результаті використання або неможливості використання нашого сайту.</li>
                </ul>
            </p>


            <h3>8. Вирішення суперечок</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Будь-які спори, що виникають у зв'язку з використанням нашого сайту,
                        повинні першочергово вирішуватись шляхом домовленості з адміністрацією сайту</li>
                    <li className={StaticPageStyles.staticPageText}>У разі неможливості досягнути домовленості, суперечки вирішуються відповідно до законів країни реєстрації власника сайту</li>
                </ul>
            </p>

            <h3>9. Контактна інформація</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Якщо у вас є будь-які питання або зауваження щодо цих умов користування,
                        будь ласка, зв'яжіться з нами за електронною адресою.</li>
                    <a href={"mailto:support@leelaonline.net"}>support@leelaonline.net</a>
                </ul>
            </p>
            <br/>
            <br/>

            <h1>Політика конфіденційності</h1>
            <a href="/confidential_policy" target="_blank">Політика конфіденційності</a>




        </div>
    )
}

export default UserConditions